// extracted by mini-css-extract-plugin
export default {"logo":"App_logo__RoCaa","container":"App_container__8bFz3","contianer":"App_contianer__KOyrT"};